/** @jsx onetext.jsx.element */

import type { OneText } from '../../../global';

// eslint-disable-next-line no-restricted-syntax
import {
    FamilySalePinkBlueFlowersCombo, FamilySalePinkFlower1, FamilySalePinkYellowFlowersCombo, FamilySaleYellowFlower1,
    FamilySaleYellowFlower2
} from '../images';

declare let onetext : OneText;

const { clsx } = onetext.jsx;

export const BrandBackgroundFamilySale = () : JSX.Element => (
    <div className={ 'absolute inset-0 overflow-hidden' }>
        { /* Top Left */ }
        <img
            src={ FamilySalePinkYellowFlowersCombo }
            className={
                clsx(
                    'absolute',
                    '-left-14 md:-left-20 w-[200px] md:w-[280px]',
                    'transform rotate-90'
                )
            } />
        <img
            src={ FamilySalePinkBlueFlowersCombo }
            className={
                clsx(
                    'absolute',
                    'left-28 w-[150px] md:w-[200px]',
                    'transform'
                )
            } />
        <img
            src={ FamilySaleYellowFlower1 }
            className={
                clsx(
                    'absolute hidden md:block',
                    'left-36 top-36 w-[80px]',
                    'transform'
                )
            } />

        { /* Bottom Right */ }

        <img
            src={ FamilySalePinkYellowFlowersCombo }
            className={
                clsx(
                    'absolute',
                    '-right-14 md:-right-20 w-[200px] bottom-0 md:w-[280px]',
                    'transform -rotate-90'
                )
            } />
        <img
            src={ FamilySalePinkBlueFlowersCombo }
            className={
                clsx(
                    'absolute',
                    'right-28 w-[150px] bottom-0 md:w-[200px]',
                    'transform rotate-180'
                )
            } />
        <img
            src={ FamilySalePinkFlower1 }
            className={
                clsx(
                    'absolute hidden md:block',
                    'right-36 bottom-36 w-[80px]',
                    'transform'
                )
            } />

        { /* Top Right */ }

        <img
            src={ FamilySalePinkBlueFlowersCombo }
            className={
                clsx(
                    'absolute',
                    '-right-16 top-0 w-[220px]',
                    'transform rotate-90'
                )
            } />
        <img
            src={ FamilySalePinkYellowFlowersCombo }
            className={
                clsx(
                    'absolute',
                    'right-16 w-[150px] md:w-[280px]',
                    'transform rotate-180'
                )
            } />
        <img
            src={ FamilySaleYellowFlower2 }
            className={
                clsx(
                    'absolute hidden md:block',
                    'right-2 top-40 w-[80px]',
                    'transform'
                )
            } />

        { /* Bottom Left */ }

        <img
            src={ FamilySalePinkBlueFlowersCombo }
            className={
                clsx(
                    'absolute',
                    '-left-16 bottom-0 w-[220px]',
                    'transform -rotate-90'
                )
            } />
        <img
            src={ FamilySalePinkYellowFlowersCombo }
            className={
                clsx(
                    'absolute',
                    'left-16 bottom-0 w-[280px]',
                    'transform '
                )
            } />
        <img
            src={ FamilySaleYellowFlower2 }
            className={
                clsx(
                    'absolute hidden md:block',
                    'left-2 bottom-40 w-[80px]',
                    'transform'
                )
            } />
    </div>
);
